<template>
  <div>
    <div class="d-flex align-items-center gap-3">
      <span class="fw-semibold">Người dùng:</span>

      <el-avatar :src="friend.avatar"></el-avatar>
      <span>{{ friend.display_name }}</span>
    </div>
    <el-table :data="friendships" style="width: 100%">
      <el-table-column prop="date" label="Tài khoản">
        <template slot-scope="scope">
          <div class="d-flex align-items-center gap-3">
            <el-avatar :src="scope.row.avatar"></el-avatar>
            <span class="fw-semibold">{{ scope.row.username }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="Trạng thái" width="120">
        <template slot-scope="scope">
          <el-button type="primary" disabled v-if="scope.row.isFriend">Bạn bè</el-button>
          <el-button type="primary" v-else>Kết bạn</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ["friend"],
  data() {
    return {
      friendships: []
    };
  },
  methods: {
    getFriendship() {
      this.$http.get("/api/contact/friendship", { params: { friendId: this.friend.uid } }).then(resp => (this.friendships = resp.data));
    }
  },
  created() {
    this.getFriendship();
  }
};
</script>
